import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid2,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LogoIcon from "../../assets/images/LogoIcon.svg";
import LogoText from "../../assets/images/LogoText.svg";
import mail from "../../assets/images/email.svg";
import passwordimg from "../../assets/images/passwordimg.svg";
import rightArrow from "../../assets/images/right.svg";
import fullName from "../../assets/images/full-name.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../utils/Snackbars";
import useRequestsWOAccessToken from "../../utils/useRequestsWOAccessToken";
import Password from "../../assets/images//password.png";
import HidePassword from "../../assets/images/hidePassword.png";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || ""; // Get the email passed from Forgot Password page
  const { postRequestWOAccessToken } = useRequestsWOAccessToken();
  // const [formData, setFormData] = useState({
  //     fullName:" ",
  //     email:"",
  // });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: email,
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email!")
        .max(255)
        .required("Login Email is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .min(8, "Password must be at least 8 characters long!")
        .max(20, "Password must not exceed 20 characters!"),
      confirmPassword: Yup.string()
        .required("Confirm new password")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match!"),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          email: values.email,
          newPassword: values.newPassword,
          confirmPassword: values.confirmPassword,
        });
        const res = await postRequestWOAccessToken("reset-password", jsonpar);
        if (res && res.code === 200) {
          setAlertData({
            variant: "success",
            message: "Password reset successfully!",
          });
          setTimeout(() => {
            navigate("/", {
              state: {
                variant: "success",
                message: "Password reset successfully!",
              },
            });
          }, 2000);
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }));
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = "Submit";
      } catch (error) {
        console.error("Error : ", error);
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred. Please try again later.",
        }));
        resetAlertData();
      }
    },
  });

  React.useEffect(() => {
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, []);

  return (
    <Grid2>
      <Link className="skip" to="/">
        Skip <img src={rightArrow} alt="" />
      </Link>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
      >
        <Box
          sx={{
            width: 500,
            padding: 4,
            borderRadius: 2,
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <Grid2 className="fullLogo">
            <div className="centerLogo">
              <img
                src={LogoIcon}
                alt="Logo"
                width={80}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className="centerLogo">
              <img src={LogoText} alt="Logo" width={180} />
            </div>
          </Grid2>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            className="signin-title"
          >
            Reset Password
          </Typography>
          <form className="loginForm">
            <div className="position-relative">
              <img
                src={mail}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Email ID"
                autoComplete="off"
                name="email"
                type="email"
                value={validation1.values.email || ""}
                disabled={true}
              />
              {validation1.touched.email && validation1.errors.email ? (
                <div className="invalid-feedback">
                  {validation1.errors.email}
                </div>
              ) : null}
            </div>
            <div className="position-relative password-field">
              <img
                src={passwordimg}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Enter New Password"
                required
                name="newPassword"
                type={showPassword ? "text" : "password"}
                className={`password-textbox form-control ${
                  validation1.touched.newPassword &&
                  validation1.errors.newPassword
                    ? "is-invalid"
                    : ""
                }`}
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                value={validation1.values.newPassword || ""}
                invalid={
                  validation1.touched.newPassword &&
                  validation1.errors.newPassword
                    ? true
                    : false
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        style={{ marginRight: "0px" }}
                      >
                        <img
                          className="password-hide-show"
                          src={showPassword ? Password : HidePassword}
                          alt="Toggle Password"
                          width={24}
                          height={24}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                // style={{borderColor:'red'}}
              />
              {validation1.touched.newPassword &&
              validation1.errors.newPassword ? (
                <div type="invalid" className="invalid-feedback">
                  {validation1.errors.newPassword}
                </div>
              ) : null}
            </div>
            <div className="position-relative password-field">
              <img
                src={passwordimg}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Confirm Password"
                required
                name="confirmPassword"
                type={confirmShowPassword ? "text" : "password"}
                className={`password-textbox form-control ${
                  validation1.touched.confirmPassword &&
                  validation1.errors.confirmPassword
                    ? "is-invalid"
                    : ""
                }`}
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                value={validation1.values.confirmPassword || ""}
                invalid={
                  validation1.touched.confirmPassword &&
                  validation1.errors.confirmPassword
                    ? true
                    : false
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setConfirmShowPassword(!confirmShowPassword)
                        }
                        edge="end"
                        style={{ marginRight: "0px" }}
                      >
                        <img
                          className="password-hide-show"
                          src={confirmShowPassword ? Password : HidePassword}
                          alt="Toggle Password"
                          width={24}
                          height={24}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                // style={{borderColor:'red'}}
              />
              {validation1.touched.confirmPassword &&
              validation1.errors.confirmPassword ? (
                <div type="invalid" className="invalid-feedback">
                  {validation1.errors.confirmPassword}
                </div>
              ) : null}
            </div>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
              type="submit"
              id="submit1"
              className="btn-common btn bg-primary text-white btn-block"
              onClick={(e) => {
                e.preventDefault();
                validation1.handleSubmit();
                return false;
              }}
            >
              {"Submit"}
            </Button>
          </form>
        </Box>
      </Box>
      <Typography className="dont">
        <Link to="/">Back</Link>
      </Typography>
    </Grid2>
  );
};
export default ResetPassword;
